import { NdpsDomainResponse } from '../../../types/bff-types';
import { fetchBff } from './bff-fetch';

export const fetchCallmeEmail = async (formData: FormData): Promise<NdpsDomainResponse | null> => {
	return fetchBff('callme/email', formData);
};
